import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useScheduleTemplates } from "@api/scheduleTemplate.api";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useScheduleHubScope } from "./ScheduleHubScopeProvider";
import {
    getAvailableScheduleHubScopes,
    resolveScheduleHubRedirectPath,
} from "./scheduleHubScope";

/** Moves a link scoped to another hub's policy over to that hub, keeping the query. */
export function useScheduleHubRedirect(templateId: string | null): void {
    const scope = useScheduleHubScope();
    const { schedulesExpenses: isExpensesAvailable } = useTypedFlags();
    const { data: templates } = useScheduleTemplates({
        includeArchived: true,
        includeMilestone: true,
    });
    const location = useLocation();
    const navigate = useStateAwareNavigate();
    const redirectPath = useMemo(
        () =>
            scope
                ? resolveScheduleHubRedirectPath({
                      scope,
                      templateId,
                      templates: templates ?? [],
                      availableScopes: getAvailableScheduleHubScopes({
                          isExpensesAvailable,
                      }),
                  })
                : null,
        [isExpensesAvailable, scope, templateId, templates],
    );

    useEffect(() => {
        if (redirectPath) {
            navigate(
                { pathname: redirectPath, search: location.search },
                { replace: true },
            );
        }
    }, [location.search, navigate, redirectPath]);
}
